var $articles = document.querySelectorAll('.fjs-nav-subradio'),
	$nav = document.querySelector('.fjs-nav-scroll');

if($articles.length) {
	for(var i = 0; i < $articles.length; i++) {
		var $article = $articles[i];
		$article.addEventListener('change', animateActive);
	}
}

function animateActive() {
	var $activeElement = this;

	if($activeElement !== null) {
//		if(window.screen.width > 1023) {		

		var centerPos = $nav.clientHeight / 2,
			$activeOffset = $activeElement.offsetTop,
			parentOffset = $activeElement.parentNode.parentNode.parentNode.parentNode.offsetTop,
			setActivePos = $activeOffset + parentOffset - centerPos,
			direction = 'top';

		if(setActivePos < 0) {
			setActivePos = 0; 
		} 
		
		var duration = 800;
		
		$nav.scrollTop = setActivePos;	
	}
}
